import { OpenLRCoordinate } from './openlrcoordinate.model';

export class OpenLRGeoCoordinate {
  openlrCoordindate: OpenLRCoordinate;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/openlrgeocoordinate.model.ts